import React from 'react';
import styled from 'styled-components';
import { Icon } from '../';
const Wrapper = styled.div `
  display: table;
  transform: translateZ(0);
  animation: star-pulse 1.5s ease infinite;

  @keyframes star-pulse {
    25% {
      transform: scale(1.15) translateZ(0);
    }
    60%,
    100% {
      transform: translateZ(0);
    }
  }
`;
export const IconAsterisk = (props) => {
    return (React.createElement(Wrapper, { className: props.className },
        React.createElement(Icon.Asterisk, null)));
};
//# sourceMappingURL=Asterisk.js.map